export interface CapacityWebEntity {
    productActivityId: string
    capacityTypeId: string
    capacity: number
  }